import { render, staticRenderFns } from "./ConfirmGroupModal.vue?vue&type=template&id=65bdafa0"
import script from "./ConfirmGroupModal.vue?vue&type=script&lang=js"
export * from "./ConfirmGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports